import React, { FunctionComponent, memo } from "react";
import { Image, Flex } from "@chakra-ui/react";

import BaseCard, { BaseCardProps } from "./BaseCard";

interface IProps extends BaseCardProps {}

const LogoCard: FunctionComponent<IProps> = memo(function Logo({ ...rest }) {
  return (
    <BaseCard {...rest}>
      <Flex w={"full"} alignItems={"center"} justifyContent={"center"}>
        <Image src="/images/logo-enposol-symbol.svg" boxSize="180px" />
      </Flex>
    </BaseCard>
  );
});

export default LogoCard;
